import * as types from './types';
import initialState from './initial-state';

export default function tribeFinderReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_TRIBES:
      return {
        ...state,
        tribes: action.payload.tribes,
        generationId: action.payload.generationId,
        generatedAt: action.payload.generatedAt,
        loading: false,
        generating: false,
        error: null,
      };

    case types.SET_LOADING:
      return { ...state, loading: action.payload };

    case types.SET_GENERATING:
      return { ...state, generating: action.payload, error: null };

    case types.SET_REGEN_POST_KEY:
      return { ...state, regenPostKey: action.payload };

    case types.UPDATE_TRIBE_POST:
      return {
        ...state,
        tribes: state.tribes.map((t) =>
          t.k === action.payload.tribeKey
            ? { ...t, post: action.payload.post }
            : t
        ),
        regenPostKey: null,
      };

    case types.SET_BRIEF:
      return {
        ...state,
        brief: action.payload.brief,
        briefIsAuto: action.payload.briefIsAuto,
        autoBrief: action.payload.autoBrief !== undefined
          ? action.payload.autoBrief
          : state.autoBrief,
      };

    case types.SET_FILTER:
      return { ...state, filter: action.payload };

    case types.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        generating: false,
        regenPostKey: null,
      };

    default:
      return state;
  }
}
